import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getPpiConfigurations } from '../ActionCreators'

export const VNPPI = () => {

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getPpiConfigurations())
  }, [])

  return <></>
}